var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-popover",
    {
      ref: "popover",
      attrs: {
        target: _vm.target,
        placement: "bottomleft",
        triggers: "click blur",
        "custom-class": _vm.customClass,
      },
    },
    [
      _c(
        "div",
        { staticClass: "menu" },
        [
          _vm._l(_vm.list, function (item, index) {
            return [
              item.link
                ? _c(
                    "a",
                    {
                      key: index,
                      staticClass: "menu-item",
                      attrs: { href: item.link },
                    },
                    [
                      item.icon
                        ? _c("svg-icon", {
                            staticClass: "menu-item__icon",
                            attrs: {
                              size: 16,
                              name: item.icon,
                              color: item.iconColor,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(item.text) + " "),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      key: index,
                      staticClass: "menu-item",
                      on: {
                        click: function ($event) {
                          return _vm.onClick(item)
                        },
                      },
                    },
                    [
                      item.icon
                        ? _c("svg-icon", {
                            staticClass: "menu-item__icon",
                            attrs: {
                              size: 16,
                              name: item.icon,
                              color: item.iconColor,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(item.text) + " "),
                    ],
                    1
                  ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }